module.exports = __webpack_public_path__ + "img/sync-bai.14a821e0.svg";